
import constants from '../../payment/common/lib/utils/constants.js';

const PENDING_STATE = 'pending';
const NOT_FOUND_STATE = 'notFound';
let defaultServerUrl;
let viewUpdateCallback;
let defaultHandlePaymentResultCallback;

function defaultHandleDepositResultCallback(paymentResultData) {
	const SUCCESSFUL_STATE = 'successful';
	const state = paymentResultData.state;
	const temporaryOrUnknownPendingState = Boolean((state === PENDING_STATE && paymentResultData.willStayInPending === false) || state === NOT_FOUND_STATE);
	const nonTemporaryPendingState = Boolean(paymentResultData.willStayInPending === true);
	const successState = Boolean(state === SUCCESSFUL_STATE);
	let handleIsDone = false;
	if (temporaryOrUnknownPendingState) {
		// Show that we want another poll by returning false
		handleIsDone = false;
	} else if (nonTemporaryPendingState) {
		viewUpdateCallback(paymentResultData, constants.PENDING);
		// Show that we are happy by returning true, so no need for another poll
		handleIsDone = true;
	} else if ((!temporaryOrUnknownPendingState || !nonTemporaryPendingState) && successState) {
		viewUpdateCallback(paymentResultData, constants.SUCCESS);
		// Show that we are happy by returning true, so no need for another poll
		handleIsDone = true;
	} else {
		viewUpdateCallback(paymentResultData, constants.CANCELLED);
		// Show that we are happy by returning true, so no need for another poll
		handleIsDone = true;
	}
	return handleIsDone;
}

function removeBonusFromShop(bonusId) {
	System.import('../../shop.js').then((shop) => {
		shop.default.removeBonusFromShop(bonusId);
	}).catch((err) => {
		console.error(err);
	});
}

function pollPaymentResult(p) {
	const serverUrl = (p.serverUrl || null);
	const handlePaymentResultCallback = (p.handlePaymentResultCallback || null);
	let numberOfTimesToTry = (p.numberOfTimesToTry || null);
	const waitTimeBetweenTriesMs = (p.waitTimeBetweenTriesMs || null);
	const accHistRef = (p.accHistRef || null);
	const doneCallback = (p.doneCallback || null);
	const continuePollingCallback = (p.continuePollingCallback || null);
	const playerCancel = (p.playerCancel || null);
	const playerRedirectedToFailUrl = (p.playerRedirectedToFailUrl || null);
	setTimeout(() => {
		jQuery.post(serverUrl, {
			accHistRef,
			playerCancel,
			playerRedirectedToFailUrl,
			numberOfTimesToTry
		}, (data) => {
			//Clear bonus from shop if successul deposit with bonus
			if (data.bonusId > 0) {
				removeBonusFromShop(data.bonusId);
			}
			if (handlePaymentResultCallback(data)) {
				// Here we have started to show successful or cancelled final result for the player
				doneCallback();
				return;
			}
			numberOfTimesToTry -= 1;
			if (numberOfTimesToTry > 0 && continuePollingCallback() === true) {
				// pollPaymentResult(serverUrl, handlePaymentResultCallback, numberOfTimesToTry,
				// waitTimeBetweenTriesMs, accHistRef, doneCallback,
				// continuePollingCallback, playerCancel, playerRedirectedToFailUrl);
				pollPaymentResult({
					serverUrl,
					handlePaymentResultCallback,
					numberOfTimesToTry,
					waitTimeBetweenTriesMs,
					accHistRef,
					doneCallback,
					continuePollingCallback,
					playerCancel,
					playerRedirectedToFailUrl
				});
			} else {
				// paymentController.trigger(paymentEvent.REMOVE_LOADING);
				// Out of luck? Show playerCancel, or pending final result or error msg if the transaction is not found yet
				if (data.state === PENDING_STATE) {
					viewUpdateCallback(data, constants.PENDING);
				} else if (data.state === NOT_FOUND_STATE && continuePollingCallback() === true) {
					viewUpdateCallback(data, constants.CANCELLED);
				}
				doneCallback();
			}
		});
	}, waitTimeBetweenTriesMs);
}

function getAsynchronousPaymentResultAndShowFinalResult(p) {
	function returnTrueFkn() {
		return true;
	}

	const accHistRef = (p.accHistRef || null);
	const serverUrl = (p.serverUrl || defaultServerUrl);
	const playerCancel = (p.playerCancel || null);
	const playerRedirectedToFailUrl = (p.playerRedirectedToFailUrl || null);
	let totalTimeToWaitInMs = (p.totalTimeToWaitInMs || null);
	const handlePaymentResultCallback = (p.handlePaymentResultCallback || defaultHandlePaymentResultCallback);
	let doneCallback = (p.doneCallback || null);
	const continuePollingCallback = (p.continuePollingCallback || returnTrueFkn);
	const DEFAULT_TOTAL_TIME_TO_WAIT_MS = 15000;
	const DEFAULT_TOTAL_TIME_TO_WAIT_MS_FAILED_TRANSACTION = 6000;
	const DEFAULT_WAIT_TIME_BEETWEEN_TRIES_MS = 3000;
	let numberOfTimesToTry = null;

	function emptyFkn() {}

	if (!totalTimeToWaitInMs) {
		if (playerRedirectedToFailUrl) {
			totalTimeToWaitInMs = DEFAULT_TOTAL_TIME_TO_WAIT_MS_FAILED_TRANSACTION;
		} else {
			totalTimeToWaitInMs = DEFAULT_TOTAL_TIME_TO_WAIT_MS;
		}
	}

	doneCallback = (doneCallback || emptyFkn);
	numberOfTimesToTry = Math.floor(totalTimeToWaitInMs / DEFAULT_WAIT_TIME_BEETWEEN_TRIES_MS);
	pollPaymentResult({
		serverUrl,
		handlePaymentResultCallback,
		numberOfTimesToTry,
		waitTimeBetweenTriesMs: DEFAULT_WAIT_TIME_BEETWEEN_TRIES_MS,
		accHistRef,
		doneCallback,
		continuePollingCallback,
		playerCancel,
		playerRedirectedToFailUrl
	});
}

const callbacks = {
	pendingAfterSingleCallback: (paymentResultData) => {
		const state = paymentResultData.state;
		if (state === PENDING_STATE) {
			viewUpdateCallback(paymentResultData, constants.PENDING);
		} else {
			viewUpdateCallback(paymentResultData, constants.CANCELLED);
		}
	}
};

function getResultCallback(handlePaymentResultCallback) {
	if (handlePaymentResultCallback) {
		if (callbacks[handlePaymentResultCallback]) {
			return callbacks[handlePaymentResultCallback];
		}
	}
	return defaultHandlePaymentResultCallback;
}

function getSynchronousDepositResultAndShowFinalResult(accHistRef, serverUrl, handlePaymentResultCallback) {
	const sUrl = (serverUrl || defaultServerUrl);
	const paymentResultCb = getResultCallback(handlePaymentResultCallback);
	viewUpdateCallback();
	jQuery.post(sUrl, {
		accHistRef
	}, (data) => {
		if (data.bonusId > 0) {
			removeBonusFromShop(data.bonusId);
		}
		paymentResultCb(data);
		viewUpdateCallback();
	});
}

function getPaymentResult(hashParams) {
	// TODO Fetch the right section to show in deposit result page.
	// hashParams looks like
	// fetch_type=fetch_type_asynch
	// &accHistRef=PR-0205601139806-7
	// &paymentFetchResultFlow=%2FPaymentFormDataService%2FgetDepositResult

	// view update will show the spinner
	viewUpdateCallback();

	const fetchUrl = hashParams.paymentFetchResultFlow || hashParams.serverUrl || defaultServerUrl;

	if (hashParams.fetch_type === constants.FETCH_TYPE_ASYNCH) {
		getAsynchronousPaymentResultAndShowFinalResult({
			accHistRef: hashParams.accHistRef,
			serverUrl: fetchUrl,
			playerCancel: hashParams.playerCancel,
			playerRedirectedToFailUrl: hashParams.playerRedirectedToFailUrl,
			totalTimeToWaitInMs: hashParams.totalTimeToWaitInMs,
			handlePaymentResultCallback: hashParams.handlePaymentResultCallback,
			doneCallback: hashParams.doneCallback,
			continuePollingCallback: hashParams.continuePollingCallback
		});
	} else {
		getSynchronousDepositResultAndShowFinalResult(hashParams.accHistRef, fetchUrl, hashParams.handlePaymentResultCallback);
	}
}

function getDefaultServerUrl(paymentType) {
	if (paymentType === 'deposit') {
		return '/PaymentFormDataService/getDepositResult';
	}
	return '/PaymentFormDataService/getWithdrawResultService';
}

function getDefaultHandlePaymentResultCallback(paymentType) {
	if (paymentType === 'deposit') {
		return defaultHandleDepositResultCallback;
	}
	return callbacks.pendingAfterSingleCallback;
}

export default {
	init(hashParams, viewUpdate, paymentType) {
		defaultServerUrl = getDefaultServerUrl(paymentType);
		viewUpdateCallback = viewUpdate;
		defaultHandlePaymentResultCallback = getDefaultHandlePaymentResultCallback(paymentType);
		getPaymentResult(hashParams);
	}
};



// WEBPACK FOOTER //
// ./mobile-core/src/components/payment-result/fetch-payment-result.js